import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CustomCursor from './CustomCursor';
import ProjectsFab from './ProjectsFab';
import SiteLoader from './SiteLoader';

export default function Layout() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <SiteLoader />
      <Header />
      <main>
        <Outlet />
      </main>
      <ProjectsFab />
      <CustomCursor />
      <Footer />
    </>
  );
}
